export type FlowType = 'pre' | 'post' | 'country' | 'vpn' | 'base' | 'adslot';

export interface CommandStep {
  id: string;
  type: 'command' | 'sleep' | 'event' | 'video' | 'mock-command';
  command?: string;
  label?: string;
  duration?: number;
  event?: string;
  substitute?: string;
  options?: Record<string, any>;
  sleep?: number;
  timeout?: number;
}

export interface FlowFilters {
  adSlots: string[];
  osVersions: string[];
  makes: string[];
  adTypes: string[];
  destTypes: string[];
  countries: string[];
}

export interface Flow {
  id: string;
  key?: string;
  name: string;
  type: FlowType;
  description?: string;
  isDefault?: boolean;
  commands: CommandStep[];
  filters?: FlowFilters;
  tags?: string[];
  updatedAt: string;
  updatedBy: string;
}

export interface FlowTypeInfo {
  type: FlowType;
  label: string;
  icon: React.ReactNode;
  count: number;
}

export const LUNA_COMMANDS = {
  UP: {
    label: 'UP',
    command:
      'luna-send -n 1 -f luna://com.webos.service.networkinput/sendSpecialKey \'{"key":"UP"}\'',
  },
  DOWN: {
    label: 'DOWN',
    command:
      'luna-send -n 1 -f luna://com.webos.service.networkinput/sendSpecialKey \'{"key":"DOWN"}\'',
  },
  LEFT: {
    label: 'LEFT',
    command:
      'luna-send -n 1 -f luna://com.webos.service.networkinput/sendSpecialKey \'{"key":"LEFT"}\'',
  },
  RIGHT: {
    label: 'RIGHT',
    command:
      'luna-send -n 1 -f luna://com.webos.service.networkinput/sendSpecialKey \'{"key":"RIGHT"}\'',
  },
  OK: {
    label: 'OK',
    command:
      'luna-send -n 1 -f luna://com.webos.service.networkinput/sendSpecialKey \'{"key":"ENTER"}\'',
  },
  BACK: {
    label: 'BACK',
    command:
      'luna-send -n 1 -f luna://com.webos.service.networkinput/sendSpecialKey \'{"key":"BACK"}\'',
  },
  HOME: {
    label: 'HOME',
    command:
      'luna-send -n 1 -f luna://com.webos.service.networkinput/sendSpecialKey \'{"key":"HOME"}\'',
  },
  MENU: {
    label: 'MENU',
    command:
      'luna-send -n 1 -f luna://com.webos.service.networkinput/sendSpecialKey \'{"key":"MENU"}\'',
  },
} as const;
